/** Visual-only metrics for the current ordered Story.
 * Source contribution is measured by selected FOOTAGE SECONDS, not passage count.
 * The preview never changes the saved paper edit, source timing, or XML.
 */
export function buildStoryOverview(blocks=[],sourceOrder=[]){
 const segments=[],grouped=new Map();let seconds=0;
 for(let i=0;i<blocks.length;i++){
  const block=blocks[i];
  const duration=Number(block?.end)-Number(block?.start);
  if(!block?.id||!block?.sourceId||!Number.isFinite(duration)||duration<=0)continue;
  segments.push({id:block.id,sourceId:block.sourceId,index:i,start:seconds,duration,
   end:seconds+duration,text:String(block.text||'').trim()});
  seconds+=duration;
  const source=grouped.get(block.sourceId)||{id:block.sourceId,seconds:0,passages:0};
  source.seconds+=duration;source.passages++;grouped.set(block.sourceId,source);
 }
 const order=[...new Set([...sourceOrder,...segments.map(s=>s.sourceId)])];
 const composition=order.filter(id=>grouped.has(id)).map(id=>{
  const info=grouped.get(id);
  return {...info,share:seconds?info.seconds/seconds:0};
 });
 return {seconds,segments:segments.map(segment=>({...segment,share:segment.duration/seconds})),composition};
}
